export default "__VITE_ASSET__a6f70658__"